import { CommonModule } from "@angular/common";
import {
  Component,
  forwardRef,
  inject,
  input,
  OnInit,
  output,
} from "@angular/core";
import {
  ControlContainer,
  ControlValueAccessor,
  FormGroup,
  FormGroupDirective,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from "@angular/forms";
import { MaterialModule } from "src/app/core/material/material.module";
import { LabelInputComponent } from "../../label-input/label-input.component";

@Component({
  selector: "app-textarea",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    LabelInputComponent,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextareaComponent),
    },
  ],
  templateUrl: "./textarea.component.html",
})
export class TextareaComponent implements OnInit, ControlValueAccessor {
  // Services
  private parent = inject(FormGroupDirective);
  ngControl = inject(NgControl, { optional: true, self: true })!;

  // Variables
  form: FormGroup = new FormGroup({});

  // Inputs
  readonly nameControl = input<string>();
  readonly textLabel = input<string>();
  readonly textTooltip = input<string>();
  readonly type = input("text");
  readonly required = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly hasTooltip = input<boolean>(false);
  readonly isGenerate = input<boolean>(false);
  readonly hasButtonGenerateIA = input<boolean>(false);
  readonly value = input<any>("");
  readonly rows = input<string>("3");
  readonly textRequired = input<string>("ValidateMessageInputRequired");
  readonly placeholder = input<string>("");

  // Getters
  get f() {
    return this.form.controls;
  }

  // Output
  readonly generateWithAi = output();

  //#region Control Value Accessor
  writeValue(value: any): void {
    this.form.controls[this.nameControl()!].setValue(value);
  }

  onChange: (_: any) => void = (_: any) => {};

  onTouched: () => void = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  //#region Livecycle Hooks
  ngOnInit() {
    if (this.ngControl != null) this.ngControl.valueAccessor = this;
    this.form = this.parent.form;
  }

  onChangeBlur() {
    this.f[this.nameControl()!].setValue(
      this.f[this.nameControl()!].value?.trim()
    );
  }
}
